import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, InputLabel, FormControl, Autocomplete, TextField } from "@mui/material";
import driverService from "src/_services/driverService";
import { useSelector } from "react-redux";

const DriversDropdownList = ({
    // drivers,
    didSelectDriver,
    value,
    mode,
    selectedDrivers,
    selectedDriver,
    ...props
}) => {

    const { t } = useTranslation();
    const { driversList, driversLoading } = useSelector((state) => state.entities.drivers);

    const handleMenuItemClick = (e, drivers) => {
        // if (mode === 'multi' && drivers.length > 1) {
        //     e.stopPropagation();
        // }
        didSelectDriver(drivers)
    }



    return (
        <FormControl variant="outlined" size="small" {...props}>
            {/* <InputLabel mb={2} color="main">
                {t("Choose Driver")}
            </InputLabel> */}
            <Autocomplete
                loading={driversLoading} 
                loadingText={t("loading data...")}
                filterSelectedOptions={mode == "multi"}
                multiple={mode == "multi"}
                color="main"
                size="small"
                sx={{ minWidth: '300px' }}
                disableClearable
                getOptionLabel={(option) => option && option.name}
                onChange={(event, newValue) => {
                    handleMenuItemClick(event, newValue)
                }}
                // onInputChange={(event, text) => {
                //     handleSeachAutoComplete(text)
                // }}
                options={driversList}
                value={mode === "multi" ? selectedDrivers : selectedDriver}
                fullWidth
                renderInput={(params) => <TextField label={t("Choose Driver")} {...params} />}
            >
                {/* {drivers.map((driver) => (
                    <MenuItem
                        onClickCapture={handleMenuItemClick}
                        key={driver.id}
                        value={driver.id}
                    >
                        {driver.name}
                    </MenuItem>
                ))} */}
            </Autocomplete>
        </FormControl>
    )
};

export default DriversDropdownList;